document.addEventListener('DOMContentLoaded', (event) => {  
 function TotalLength(el){

    var path = document.querySelectorAll(el);
    if($(el).length > 0){
      for (let elem of path) {
        if(elem.getAttribute("stroke-dasharray")){
          var len = Math.round(elem.getTotalLength() );
          elem.setAttribute("stroke-dasharray", len);
          elem.setAttribute("stroke-dashoffset", len);
          elem.classList.add('draw');
        }
      }
    }
  };
 var header_banner = $('.header-banner.with-animation');
  if(header_banner){
    header_banner.find('.z-top__header').css('opacity','1');
    TotalLength('#actuator-with-usp #Oval');
    TotalLength('#actuator-with-usp #Path');
    setTimeout(function() {
      header_banner.find('.z-top__text').css('opacity','1');
      header_banner.find('.header-content-icons-block svg').css('opacity','1');
      header_banner.find('.header-content-icons-block img').css('opacity','1');
      header_banner.find('#logo_actuators_landing').css('opacity','1');
      TotalLength('#actuator-icon-collection path');
      TotalLength('#actuator-icon-collection #Oval');
      TotalLength('#actuator-icon-collection #Path');
    }, 1000);
    setTimeout(function() {
      header_banner.find('.btn').css('opacity','1');
      header_banner.find('.swiper-container').css('opacity','1');
      header_banner.find('.brands-slide').css('opacity','1');
      TotalLength('#actuator-icon path');
      TotalLength('#actuator-icon #Oval');
      TotalLength('#product_icon #Path');
      TotalLength('#product_icon #Oval');
      header_banner.find('.header-content-icons-title').css('opacity','1');
      header_banner.find('.header-svg circle').css('opacity','1');
      header_banner.find('#actuator-with-usp .path-fill').addClass('full');
      header_banner.find('#actuator-with-usp .path-fill-dark').addClass('full');
    }, 2000);
    setTimeout(function() {
      header_banner.find('#actuator-icon .path-fill').addClass('full');
      header_banner.find('#product_icon .path-fill').addClass('full');
      header_banner.find('#product_icon .path-fill-dark').addClass('full');
      header_banner.find('#actuator-with-usp .path-fill-white').addClass('full');
    }, 2600);
  }

  const banner_svg =  $('.banner_without_images');
 
 if(banner_svg.length){
  
    banner_svg.find('.banner__heading').css('opacity','1');

   if($('#actuator-with-usp').length) {
    TotalLength('#actuator-with-usp #Oval');
    TotalLength('#actuator-with-usp #Path');
   }
  
    setTimeout(function() {
      banner_svg.find('.banner__text').css('opacity','1');
      banner_svg.find('.header-content-icons-block svg').css('opacity','1');
      banner_svg.find('.header-content-icons-block img').css('opacity','1');
      banner_svg.find('#logo_actuators_landing').css('opacity','1');
      if($('#actuator-icon-collection').length) {
      TotalLength('#actuator-icon-collection path');
      TotalLength('#actuator-icon-collection #Oval');
      TotalLength('#actuator-icon-collection #Path');
      }
    }, 1000);
    setTimeout(function() {
      banner_svg.find('.button').css('opacity','1');
      if($('#actuator-icon').length) {
      TotalLength('#actuator-icon path');
      TotalLength('#actuator-icon #Oval');
      }
        if($('#product_icon').length) {
      TotalLength('#product_icon #Path');
      TotalLength('#product_icon #Oval');
        }
      banner_svg.find('.header-content-icons-title').css('opacity','1');
      banner_svg.find('.header-svg circle').css('opacity','1');
      banner_svg.find('#actuator-with-usp .path-fill').addClass('full');
      banner_svg.find('#actuator-with-usp .path-fill-dark').addClass('full');
    }, 2000);
    setTimeout(function() {
      banner_svg.find('#actuator-icon .path-fill').addClass('full');
      banner_svg.find('#product_icon .path-fill').addClass('full');
      banner_svg.find('#product_icon .path-fill-dark').addClass('full');
      banner_svg.find('#actuator-with-usp .path-fill-white').addClass('full');
    }, 2600);
  }

  const banner_with_custom_data_SectionEl = $('.banner_with_custom_data');
  if(banner_with_custom_data_SectionEl.length) {

    function timedCounter(finalValue, seconds, callback){

  var startTime = (new Date).getTime();
  var milliseconds = seconds*1000;

  (function update(){

    var currentTime = (new Date).getTime();
    var value = finalValue*(currentTime - startTime)/milliseconds;

    if(value >= finalValue)
      value = finalValue;
    else
      setTimeout(update, 0);

    callback && callback(value);

  })();

}
    function isFloat(n) {
    return Number(n) === n && n % 1 !== 0;
}
    function banner_with_custom_data__header__FadeIn() {
        banner_with_custom_data_SectionEl.find('.banner_with_custom_data__header').css('opacity','1');
        const statistic_block_numArr = banner_with_custom_data_SectionEl[0].querySelectorAll('.info_stat_block_num');
        if(statistic_block_numArr.length) {
          for(const statistic_block of statistic_block_numArr) {
            const finish_count = statistic_block.getAttribute('data-finish-count') * 1;
            const statistic_block_innerEl = statistic_block.querySelector('span');
            timedCounter(finish_count, 2.5, function (value) {
             if(isFloat(finish_count)) {
               let float_length = finish_count.toString().split('.')[1].split('').length;
                statistic_block_innerEl.innerHTML = value.toFixed(float_length);
             } else {
                statistic_block_innerEl.innerHTML = value.toFixed(0);
             }
             
            });
          }
        } 
    }
    
      banner_with_custom_data_SectionEl.find('.banner__heading').css('opacity','1');
      if(banner_with_custom_data_SectionEl.find('.banner_with_custom_data__header').length) {
          banner_with_custom_data__header__FadeIn();
      }
      setTimeout(function() {
          banner_with_custom_data_SectionEl.find('.banner__text').css('opacity','1');
      }, 1000);
      if( banner_with_custom_data_SectionEl.find('.button').length) {
        setTimeout(function() {
      banner_with_custom_data_SectionEl.find('.button').css('opacity','1');
    }, 2000);
    }
  }
    
});